import React, { FC } from 'react';
import styled from 'styled-components';
import { mobile, tablet } from 'styles/breakpoints';
import Text from 'components/Text';
import ContinueButton from './QuizContinueButton';
import { DynamicImage } from 'components';
import { table } from 'console';
import { useSelector } from 'react-redux';
import { AppState } from 'state/types';
import resultsSvgs from 'utils/constants/resultsSvgs';

interface InfoProps {
  onContinue: () => void;
  title: string;
  list: string[];
  buttonTitle: string;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  padding: 3.25rem 1rem 3rem;
  @media ${tablet} {
    padding: 2.375rem 1rem;
  }
`;

const Title = styled(Text)`
  color: #fff;
  text-align: center;

  font-size: 1.5rem;
  font-style: normal;
  font-weight: 700;
  line-height: 2rem;
  span {
    display: block;
    color: #f7c800;
  }
  margin-bottom: 1.75rem;
  @media ${tablet} {
    font-size: 1.1875rem;
    line-height: 2rem;
    margin-bottom: 1rem;
  }
`;

const Content = styled.div`
  width: 100%;
  max-width: 28.75rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 1.5rem;
  margin-bottom: 5rem;
  border-radius: 1.5rem;
  border: 1px solid rgba(132, 141, 159, 0.57);
  background: #001736;
  @media ${tablet} {
    padding: 1.5rem;
  }
`;

const ListItem = styled.div`
  color: #fff;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
  @media ${tablet} {
    font-size: 0.8125rem;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: -0.0195rem;
  }
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const SvgContainer = styled.div`
  width: 1.58538rem;
  height: 1.58538rem;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.875rem;
  align-self: stretch;
`;

const InfoList: FC<InfoProps> = ({
  title,
  list,
  buttonTitle,
  onContinue,
  ...props
}) => {
  const renderSvgImage = (svgKey: string) => {
    const Svg = resultsSvgs[svgKey];
    return <Svg />;
  };
  return (
    <Container {...props}>
      <Content>
        <Title dangerouslySetInnerHTML={{ __html: title }} />
        <List>
          {list?.map((item, i) => (
            <Item key={i}>
              <SvgContainer>{renderSvgImage('star')}</SvgContainer>
              <ListItem dangerouslySetInnerHTML={{ __html: item }} />
            </Item>
          ))}
        </List>
      </Content>

      <ContinueButton title={buttonTitle} onClick={onContinue} />
    </Container>
  );
};

export default InfoList;
